__turbopack_context__.v({
  "ratings": "condition-ratings-modal-module-scss-module__s8dRaW__ratings",
  "trigger": "condition-ratings-modal-module-scss-module__s8dRaW__trigger",
  "u-animation-bounce": "condition-ratings-modal-module-scss-module__s8dRaW__u-animation-bounce",
});
